// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
import { styled } from '@/styled-system/jsx';
import { cva } from '@/styled-system/css';

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
export const StyledFlex = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export const boxContainerStyles = cva({
  base: {
    padding: 'default',
    borderRadius: '{radii.obj.sharp}',
    border: '1px solid',
    borderColor: 'border.muted',
  },
  variants: {
    isEditMode: {
      true: {
        padding: 'zero',
        borderWidth: '0px',
        borderColor: 'transparent',
      },
    },
  },
});
